//button-with-underline
if (window.screen.width > 990) {
  let attachedFullScreen = false;

  let fullScreenSection = document.querySelector('.product-full-screen-section');

  let imageContainerFullScreen = fullScreenSection.querySelector('.button--with-underline--container');

  const followMouseFullScreen = (event) => {
    if (imageContainerFullScreen) {
      imageContainerFullScreen.style.left = event.pageX + 'px';
      imageContainerFullScreen.style.top = event.pageY + 30 + 'px';
    }
  };

  /* exported showTextFull */
  // eslint-disable-next-line no-unused-vars
  function showTextFull() {
    if (!attachedFullScreen && imageContainerFullScreen) {
      attachedFullScreen = true;
      imageContainerFullScreen.style.display = 'block';
      document.addEventListener('pointermove', followMouseFullScreen);
    }
  }

  /* exported hideTextFull */
  // eslint-disable-next-line no-unused-vars
  function hideTextFull() {
    if (imageContainerFullScreen) {
      attachedFullScreen = false;
      imageContainerFullScreen.style.display = '';
      document.removeEventListener('pointermove', followMouseMarkers);
    }
  }
}
